module.exports = __webpack_public_path__ + "img/rooster.4e4e5860.svg";